// Infinite scroll does not work when limit is so small that no scrollbar appears in the window.
// See issue https://github.com/ankeetmaini/react-infinite-scroll-component/issues/286
export const LIMIT = 500;
